/* Fann Bliss product page V2 (snippets/fpd-block.liquid, sections/fann-pdp-related.liquid).
   - promise block: the "AED 35 each when you buy 9+" pill, read from the bundles section's pricing rules
   - "Customize this design": open/close, counter, and the note only joins the order once something is typed
   - "Complete the pair": the bundles section's pair offers, pulled up under the buy button
   - sticky add to bag: mirrors the main button and presses it, so every check and note still applies
   - "Same design, other pieces": other products whose title starts with this design's name
   - the main button reads "Add to bag · AED 80" everywhere, and Recently viewed skips the product you are on
   - Buy more, pay less: pair cards get a "Pick your mug" button (desktop card shape)
   - Details & delivery: long descriptions fold on phones ([data-fpd-desc])
   - You might also like: Shopify recommendations loaded into sections/fann-pdp-recs.liquid ([data-fpd-recs])
   - Bulk orders: links to #bulk-orders open the request form ([data-fpd-bulk]) */
(function () {
  'use strict';
  if (window.__fpdV2) return; window.__fpdV2 = 1;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function money(c) { c = Math.round(c); return 'AED ' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function fill(t, o) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function whenReady(test, cb, tries) {
    tries = tries == null ? 60 : tries;
    var v = test(); if (v) return cb(v);
    if (tries <= 0) return;
    setTimeout(function () { whenReady(test, cb, tries - 1); }, 150);
  }
  function mainButton() {
    var f = $('.productView-details form[data-type="add-to-cart-form"]') || $('form[data-type="add-to-cart-form"]');
    return f && (f.querySelector('#product-add-to-cart') || f.querySelector('[name="add"]'));
  }
  function rules() {
    var n = $('script[data-fh-rules]'); if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }

  /* ------------------------------------------------------------ best quantity price pill */
  function initLadder() {
    $$('[data-fpd-ladder]').forEach(function (el) {
      var R = rules(); if (!R || !R.ladders) return;
      var fam = el.getAttribute('data-fam'), price = parseInt(el.getAttribute('data-price'), 10) || 0;
      var best = null;
      R.ladders.forEach(function (L) { if (L.fam === fam && (!best || L.off > best.off)) best = L; });
      if (!best || !price) return;
      var each = price - Math.round(best.off * 100);
      if (each <= 0 || each >= price) return;
      el.querySelector('span').textContent = fill(el.getAttribute('data-tpl'), { price: money(each), min: best.min });
      el.hidden = false;
    });
  }

  /* ------------------------------------------------------------ "Customize this design" */
  function initCustomize() {
    $$('[data-fpd-cz]').forEach(function (box) {
      var btn = $('.fpd-cz-toggle', box), body = $('.fpd-cz-body', box), ta = $('textarea', box), count = $('[data-fpd-cz-count]', box), sub = $('[data-fpd-cz-sub]', box);
      if (!btn || !body || !ta) return;
      var named = $$('[data-fpd-name]', box);
      function setOpen(on, focus) {
        body.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false'); box.classList.toggle('is-open', on);
        if (on && focus) setTimeout(function () { ta.focus({ preventScroll: true }); }, reduce ? 0 : 120);
      }
      function sync() {
        var v = ta.value.trim();
        named.forEach(function (f) { if (v) f.setAttribute('name', f.getAttribute('data-fpd-name')); else f.removeAttribute('name'); });
        if (count) count.textContent = ta.value.length + '/' + ta.maxLength;
        box.classList.toggle('has-note', !!v);
        if (sub) sub.textContent = v ? fill(sub.getAttribute('data-added'), { note: v.length > 38 ? v.slice(0, 36) + '…' : v }) : sub.getAttribute('data-sub');
      }
      btn.addEventListener('click', function () { setOpen(body.hidden, true); });
      ta.addEventListener('input', sync);
      setOpen(box.hasAttribute('data-open'), false);
      sync();
    });
  }

  /* ------------------------------------------------------------ "Complete the pair" */
  function initPair() {
    $$('[data-fpd-pair]').forEach(function (box) {
      var list = $('[data-fpd-pair-list]', box), max = parseInt(box.getAttribute('data-max'), 10) || 2;
      whenReady(function () {
        var sec = $('.fh-pdpb'); if (!sec || sec.hidden) return null;
        var b = $$('.fb-pairs .fb-pair[data-fb-open]', sec);
        return b.length ? b : null;
      }, function (btns) {
        var ranked = btns.map(function (b) {
          var t = ($('.fb-pair-s', b) || {}).textContent || '', m = t.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
          return { b: b, save: m ? parseFloat(m[1]) : 0 };
        }).sort(function (x, y) { return y.save - x.save; }).slice(0, max);
        ranked.forEach(function (r) {
          var li = document.createElement('li'), c = r.b.cloneNode(true);
          c.removeAttribute('data-fb-open'); c.removeAttribute('id');
          c.addEventListener('click', function (e) { e.preventDefault(); r.b.click(); });
          li.appendChild(c); list.appendChild(li);
        });
        if (ranked.length) box.hidden = false;
      });
    });
  }

  /* ------------------------------------------------------------ one label for the buy button */
  function tidyLabel(btn) {
    if (!btn) return;
    var t = btn.textContent.replace(/\s+/g, ' ').trim();
    if (!/^add to cart/i.test(t)) return;
    var n = t.replace(/^add to cart/i, 'Add to bag').replace(/\s*-\s*(AED|Dhs?\.?)/i, ' · $1').replace(/(\d)\.00\b/, '$1');
    if (n !== t) btn.textContent = n;
  }
  function initLabel() {
    var btn = mainButton(); if (!btn) return;
    tidyLabel(btn);
    if (window.MutationObserver) new MutationObserver(function () { tidyLabel(btn); }).observe(btn, { childList: true, characterData: true, subtree: true });
  }

  /* ------------------------------------------------------------ sticky add to bag */
  function initSticky() {
    var bar = $('[data-fpd-sticky]'), btn = mainButton();
    if (!bar || !btn) return;
    document.body.appendChild(bar);
    var sb = $('[data-fpd-sticky-btn]', bar), mainIn = true, footIn = false, root = document.documentElement;
    function label() {
      var t = btn.textContent.replace(/\s+/g, ' ').trim();
      sb.textContent = t || sb.textContent;
      sb.disabled = !!btn.disabled;
      /* same colours as the main button, which come from the theme editor */
      if (!btn.disabled) {
        var cs = getComputedStyle(btn), bg = cs.backgroundColor;
        if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') { sb.style.background = bg; sb.style.color = cs.color; }
      }
    }
    function show() {
      var on = !mainIn && !footIn && !root.classList.contains('fb-hide-mbar') && !document.body.classList.contains('quickshop-popup-show');
      if (on === !bar.hidden) return;
      bar.hidden = !on; root.classList.toggle('fpd-sticky-on', on);
    }
    sb.addEventListener('click', function () {
      if (btn.disabled) { btn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
      btn.click();
    });
    label();
    if (window.MutationObserver) new MutationObserver(label).observe(btn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { mainIn = e.isIntersecting; }); show(); }, { rootMargin: '0px 0px -60px 0px' }).observe(btn);
      var foot = $('footer, .footer, #shopify-section-footer, [id*="__footer"]');
      if (foot) new IntersectionObserver(function (es) { es.forEach(function (e) { footIn = e.isIntersecting; }); show(); }).observe(foot);
    } else { mainIn = false; show(); }
    if (window.MutationObserver) new MutationObserver(show).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------ same design, other pieces */
  var STOP = /^(.*?)\s+(?:\d+\s?ml\b|mug\b|mugs\b|tumbler\b|bottle\b|coaster\b|ceramic\b|teacher\b|water\b|kids\b|stainless\b|magsafe\b|[-–|·]\s)/i;
  function designOf(title) {
    var t = String(title || '').replace(/\s+/g, ' ').trim(), m = t.match(STOP);
    return (m ? m[1] : '').trim();
  }
  function initRelated() {
    $$('[data-fpd-related]').forEach(function (sec) {
      var handle = sec.getAttribute('data-handle'), name = sec.getAttribute('data-design') || designOf(sec.getAttribute('data-title'));
      var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4, list = $('[data-fpd-related-list]', sec);
      if (!name || name.length < 3 || /^custom$/i.test(name) || /^custom-/.test(handle)) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(name) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title';
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        var items = (((d || {}).resources || {}).results || {}).products || [], key = name.toLowerCase();
        items = items.filter(function (p) { return p.handle !== handle && p.available !== false && designOf(p.title).toLowerCase() === key; }).slice(0, limit);
        if (!items.length) return;
        var view = sec.getAttribute('data-view') || 'View';
        list.innerHTML = items.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=480';
          var price = parseFloat(String(p.price || p.price_min || '0').replace(/[^\d.]/g, '')) || 0;
          return '<li><a class="fpd-rel-card" href="' + esc(p.url) + '">' +
            '<span class="fpd-rel-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async" width="480" height="480">' : '') + '</span>' +
            '<span class="fpd-rel-t">' + esc(p.title) + '</span>' +
            '<span class="fpd-rel-p">' + (price ? esc(money(Math.round(price * 100))) : '') + '<em>' + esc(view) + '</em></span></a></li>';
        }).join('');
        sec.hidden = false;
      }).catch(function () {});
    });
  }

  /* ------------------------------------------------------------ recently viewed: not the product you are on */
  function initRecent() {
    var sec = $('.halo-recently-viewed-block-sections'); if (!sec) return;
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var handle = decodeURIComponent(m[1]);
    function prune() {
      $$('a[href*="/products/' + handle + '"]', sec).forEach(function (a) {
        var item = a.closest('.product-item, .product-card, .card, .product, .item');
        var col = item && (item.closest('.slick-slide') || item.parentElement);
        if (col && col.style.display !== 'none') col.style.display = 'none';
      });
    }
    prune();
    if (window.MutationObserver) new MutationObserver(prune).observe(sec, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------ Buy more, pay less: a "Pick your mug" button on pair cards
     (shown on desktop, where pairs and sets share one card shape) */
  var ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';
  function initPairCta() {
    var sec = $('.fh-pdpb'); if (!sec) return;
    function add() {
      $$('.fb-pairs .fb-pair', sec).forEach(function (b) {
        if (b.querySelector('.fpd-pair-go')) return;
        var t = (($('.fb-pair-t small', b) || {}).textContent || '').trim(), m = t.match(/any\s+(.+)$/i);
        var span = document.createElement('span');
        span.className = 'fpd-pair-go';
        span.innerHTML = esc(m ? 'Pick your ' + m[1] : 'Pick designs') + ARROW;
        b.appendChild(span);
      });
    }
    add();
    if (window.MutationObserver) new MutationObserver(add).observe(sec, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------ Details: long descriptions fold on phones */
  function initDesc() {
    $$('[data-fpd-desc]').forEach(function (box) {
      var inner = $('[data-fpd-desc-in]', box), btn = $('[data-fpd-desc-more]', box);
      if (!inner || !btn) return;
      var mq = window.matchMedia('(max-width: 899px)');
      function fit() {
        var open = btn.getAttribute('aria-expanded') === 'true';
        box.classList.remove('is-clamped');
        var long = mq.matches && inner.scrollHeight > 330;
        btn.hidden = !long;
        if (long && !open) box.classList.add('is-clamped');
      }
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.firstChild.nodeValue = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        box.classList.toggle('is-clamped', !open);
        if (!open) box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      fit();
      if (mq.addEventListener) mq.addEventListener('change', fit);
      window.addEventListener('load', fit);
    });
  }

  /* ------------------------------------------------------------ You might also like: Shopify recommendations, filled in */
  function initRecs() {
    $$('[data-fpd-recs]').forEach(function (sec) {
      var url = sec.getAttribute('data-url');
      if (sec.querySelector('[data-fpd-recs-row]')) { initRecsNav(sec); return; }
      if (!url) return;
      var go = function () {
        fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html'), got = doc.querySelector('[data-fpd-recs]');
          if (!got || !got.querySelector('.fpd-rc')) return;
          sec.innerHTML = got.innerHTML;
          sec.hidden = false;
          initRecsNav(sec);
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '600px 0px' });
        io.observe(sec.parentElement || sec);
      } else { go(); }
    });
  }

  /* Arrows + dots for the swipe row: only when there are more cards than fit, so it reads as a slider. */
  function initRecsNav(sec) {
    var row = sec.querySelector('[data-fpd-recs-row]'), nav = sec.querySelector('[data-fpd-recs-nav]');
    if (!row || !nav) return;
    var prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]'), dots = nav.querySelector('[data-fpd-recs-dots]');
    var cards = row.children, pages = 0, raf = 0;
    function step() {
      var first = cards[0]; if (!first) return row.clientWidth;
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0, w = first.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((row.clientWidth + gap) / w)) * w;
    }
    function update() {
      raf = 0;
      var max = row.scrollWidth - row.clientWidth, show = max > 4;
      nav.hidden = !show;
      if (!show) return;
      var n = Math.max(2, Math.round(row.scrollWidth / step()));
      if (n !== pages) {
        pages = n; dots.innerHTML = '';
        for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
      }
      var at = row.scrollLeft, cur = at >= max - 4 ? pages - 1 : Math.min(pages - 1, Math.round(at / step()));
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === cur); });
      prev.disabled = at <= 4;
      next.disabled = at >= max - 4;
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () {
        row.scrollBy({ left: step() * (+b.getAttribute('data-dir')), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    row.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* ------------------------------------------------------------ Bulk orders: links open the request form */
  function initBulk() {
    var card = $('[data-fpd-bulk]'); if (!card) return;
    function openIt(e) {
      if (e) e.preventDefault();
      card.open = true;
      card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      var first = card.querySelector('.fpd-bulk-body input:not([type="hidden"]), .fpd-bulk-body textarea');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    }
    $$('[data-fpd-bulk-link], a[href="#' + (card.closest('section') || {}).id + '"]').forEach(function (a) { a.addEventListener('click', openIt); });
    if (location.hash && card.closest('section') && location.hash === '#' + card.closest('section').id) openIt();
    if (/contact_posted=true/.test(location.search)) card.open = true;
  }

  function init() {
    try { initLadder(); } catch (e) {}
    try { initCustomize(); } catch (e) {}
    try { initPair(); } catch (e) {}
    try { initLabel(); } catch (e) {}
    try { initSticky(); } catch (e) {}
    try { initRelated(); } catch (e) {}
    try { initRecent(); } catch (e) {}
    try { initPairCta(); } catch (e) {}
    try { initDesc(); } catch (e) {}
    try { initRecs(); } catch (e) {}
    try { initBulk(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
